export enum SystemTypeEnum {
  none = 'NONE',
  control = 'CONTROL',
  gateway = 'GATEWAY',
  keypad = 'KEYPAD',
  fingerprint = 'FINGER_PRINT'
}